module.exports = __webpack_public_path__ + "img/tpc-40.ee771ff0.jpg";